import { fetchResearchCoverageProductsNotSearched } from '@/api/business/marketResearch'
import { useQuery } from '@tanstack/react-query'

export const ResearchCoverageProductsNotSearchedKeys = {
    all: ['researchcoverageproductsnotsearched'] as const,
    lists: () => [...ResearchCoverageProductsNotSearchedKeys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...ResearchCoverageProductsNotSearchedKeys.lists(), page, perPage, filters] as const,
    details: () => [...ResearchCoverageProductsNotSearchedKeys.all, 'detail'] as const,
    detail: (params: number) => [...ResearchCoverageProductsNotSearchedKeys.details(), params] as const,
}

export const useResearchCoverageProductsNotSearchedQuery = (SK_PESQUISA: number) => {
    return useQuery({
        queryFn: () => fetchResearchCoverageProductsNotSearched(SK_PESQUISA),
        queryKey: ResearchCoverageProductsNotSearchedKeys.detail(SK_PESQUISA),
    })
}
